import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"


import { ref, onMounted, computed } from 'vue'
import { FollowAlarmParams } from '@/typings/api/analysis'
import { followAlarmGet } from '@/api/overseasSales/analysis'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import { listByParamCodes } from '@/api/common'
import { alarmTypeEnum, alarmLevelEnum, alarmProcessStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { useI18n } from 'vue-i18n'
const __default__ = { name: 'DcCosOFbuFollowChangeFeedback' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  cosId: {
    type: String,
    require: true
  }
},
  setup(__props) {

const { t } = useI18n()
const paramCodeData = ref<any>({
  ofbu_change_description: [] // 异动说明
})
const props = __props
const columns = computed(() => [
  {
    title: t('exception.exceptionTime'),
    dataIndex: 'alarmDate'
  },
  {
    title: t('custom.arkCode'),
    dataIndex: 'arkCode'
  },
  {
    title: t('exception.exceptionType'),
    dataIndex: 'alarmType',
    dicData: alarmTypeEnum
  },
  {
    title: t('exception.exceptionLevel'),
    dataIndex: 'alarmLevel',
    dicData: alarmLevelEnum
  },
  {
    title: t('exception.exceptionReason'),
    dataIndex: 'alarmInfo'
  },
  {
    title: t('exception.exceptionDes'),
    dataIndex: 'alarmDesc',
    dicData: paramCodeData.value.ofbu_change_description
  },
  {
    title: t('follow.processDetail'),
    dataIndex: 'process'
  },
  {
    title: t('exception.followUpTime'),
    dataIndex: 'processTime'
  },
  {
    title: t('exception.followUpDes'),
    dataIndex: 'processStatus',
    dicData: alarmProcessStatusEnum
  }
])
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_change_description']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const fetch = (params: FollowAlarmParams, callBack: (res: any) => void) => {
  if (!props.cosId) {
    callBack({
      items: [],
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPage: 0
    })
    return
  }
  followAlarmGet({
    ...params,
    cosId: props.cosId
  }).then((res) => {
    callBack(res)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_cos_table = _resolveComponent("cos-table")!

  return (_openBlock(), _createBlock(_component_cos_table, {
    columns: columns.value,
    onFetch: fetch,
    tableId: "ofbuClientsFollowChangeFeedback"
  }, {
    bodyCell: _withCtx(({ column, text }) => [
      (column.dataIndex === 'process')
        ? (_openBlock(), _createBlock(EditorTableText, {
            key: 0,
            value: text
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns"]))
}
}

})